"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DefaultStyles_1 = __importDefault(require("@CommonFrontendBackend/StyleService/DefaultStyles"));
var lodash_1 = __importDefault(require("lodash"));
var cleanJson = require("CleanJson/CleanJson").default;
var ConvertStyle_1 = __importStar(require("./ConvertStyle"));
var lodash_2 = require("lodash");
var blockConfigUtil_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/blockConfigUtil");
var PrepareStyles_1 = require("./PrepareStyles");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var v0FactoryStyles = require("Project/BlockNew/Menu/StyleSelector/FactoryStyles");
exports.default = (function ($http, apiBaseUrl, $q, styleService, loadingIndicator, invoke, account, addDefaultTcdcStyle, savedStyleService, accountService, brandStore) {
    var convertProject = function (project) { return __awaiter(void 0, void 0, void 0, function () {
        var projectStyles, newStyles;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getStylesToBeConverted(project)];
                case 1:
                    projectStyles = _a.sent();
                    return [4, convertAndAddStyles(projectStyles)];
                case 2:
                    _a.sent();
                    return [4, savedStyleService.getAllSavedStyles()];
                case 3:
                    newStyles = _a.sent();
                    project.blocks.forEach(function (block) {
                        var newStyle = newStyles.find(function (style) {
                            return block.settings.style === style.preTcdcRef && (0, ConvertStyle_1.isOldStyleCompatibleWithBlockType)(style, block.type);
                        });
                        if (!newStyle) {
                            addDefaultTcdcStyle(block);
                            if (block.type === commonTypes_1.BlockType.Video) {
                                block.style.p.alignment = "center";
                                block.style.h2.alignment = "center";
                                block.style.h1.alignment = "center";
                                (0, blockConfigUtil_1.addHash)(block.style);
                            }
                            return;
                        }
                        block.style = lodash_1.default.merge(__assign(__assign({}, (0, lodash_2.cloneDeep)(newStyle)), { clonedFrom: newStyle._id }), block.style);
                        delete block.style._id;
                        delete block.settings.style;
                    });
                    return [4, updateProjectBlocksAndAccount(project)];
                case 4:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var convertStyle = invoke(ConvertStyle_1.default);
    var updateProject = function (project) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    project.usingTCDC = true;
                    return [4, $http.post("".concat(apiBaseUrl, "/projects/").concat(project._id), { usingTCDC: true })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var updateProjectBlocksAndAccount = function (project) { return __awaiter(void 0, void 0, void 0, function () {
        var blockData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    blockData = {};
                    if (!project.blocks.length) return [3, 2];
                    project.blocks.forEach(function (block) {
                        blockData[block._id] = cleanJson(block);
                    });
                    return [4, $http.post("".concat(apiBaseUrl, "/projects/").concat(project._id, "/blocks/persist-all"), blockData)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [4, Promise.all([updateProject(project), accountService.setStyleVersion(2)])];
                case 3:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var convertAndAddStyles = function (styles) { return __awaiter(void 0, void 0, void 0, function () {
        var newStyles;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newStyles = styles
                        .filter(function (style) {
                        return style.blockType !== "Quote";
                    })
                        .map(function (style) {
                        var newStyle = (0, PrepareStyles_1.prepareStyle)(convertStyle(style), brandStore);
                        (0, blockConfigUtil_1.addHash)(newStyle);
                        return newStyle;
                    });
                    if (!newStyles.length) return [3, 2];
                    return [4, addStyles(newStyles)];
                case 1: return [2, _a.sent()];
                case 2: return [2];
            }
        });
    }); };
    var addStyles = function (styles) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, $http.post("".concat(apiBaseUrl, "/styles-bulk"), { styles: styles })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var getCurrentV2Styles = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, $http.get("".concat(apiBaseUrl, "/styles"))];
                case 1:
                    response = _a.sent();
                    return [2, response.data.message];
            }
        });
    }); };
    var getCurrentV2StyleNames = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getCurrentV2Styles()];
                case 1: return [2, (_a.sent()).map(function (style) { return style.preTcdcRef; })];
            }
        });
    }); };
    var getPreTcdcStyles = function () {
        return __spreadArray(__spreadArray(__spreadArray([], __read((account.styleVersion === 2 ? [] : account.styles)), false), __read(DefaultStyles_1.default), false), __read(v0FactoryStyles.filter(function (style) { return style.className !== "qwilr-standard"; })), false);
    };
    var getStylesToBeConverted = function (project) { return __awaiter(void 0, void 0, void 0, function () {
        var currentV2StyleNames, projectBlockStyleNames, preTcdcStyles;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getCurrentV2StyleNames()];
                case 1:
                    currentV2StyleNames = _a.sent();
                    projectBlockStyleNames = project.blocks.map(function (block) { return block.settings.style; });
                    preTcdcStyles = getPreTcdcStyles();
                    return [2, preTcdcStyles.filter(function (style) {
                            if (currentV2StyleNames.includes(style.className)) {
                                return false;
                            }
                            else if (projectBlockStyleNames.includes(style.className)) {
                                currentV2StyleNames.push(style.className);
                                return true;
                            }
                            else {
                                return !style.isFactoryStyle;
                            }
                        })];
            }
        });
    }); };
    return convertProject;
});
